import {ModalWithHeader} from "../../ui/Modal";
import React, {useMemo} from "react";
import {ModalWithHeaderProps, WalletType} from "../../types";
import {useIntl} from "react-intl";
import {DEFAULT_WALLET_METHODS, useWalletConfig, WALLET_METHODS} from "../../hooks/useConfig";
import {RecommendItem} from "../LoginBox";
import {useUserInfo} from "../../hooks";
import useAppConfig from "../../hooks/useAppConfig";

type WalletModalProps = ModalWithHeaderProps & {
    type?: 'login' | 'bind' | ''
    methods?: WalletType[]
}

function WalletConnectModal({
                                type,
                                methods: _methods,
                                ...props
                            }: WalletModalProps) {
    const intl = useIntl()
    const {walletMap} = useWalletConfig()
    const {bind, login} = useUserInfo()
    const config = useAppConfig()
    const methods = useMemo(() => {
        if (_methods) return _methods
        if (!config.platform) {
            return []
        }
        const platform = config.platform.map(p => p.toLowerCase())
        return WALLET_METHODS.filter(m => platform.includes(m))
    }, [config.platform, _methods])
    return <ModalWithHeader {...props} title={props.title || (intl.formatMessage({
        id: type == "bind" ? "bindWith" : "loginWith"
    }, {
        name: ""
    }))}>
        <div className="matchid-login-box">
            <div className="matchid-login-recommend-list">
                {
                    methods.map((method, index) => {
                        const m = walletMap[method]
                        return <RecommendItem
                            icon={m?.icon}
                            name={m?.name}
                            onClick={() => {
                                type == 'bind' ? bind(method) : login(method)
                            }
                            }
                            key={method}
                        />
                    })
                }
            </div>
        </div>
    </ModalWithHeader>
}

export default function WalletModal(props: WalletModalProps) {
    return props.isOpen && <WalletConnectModal {...props}/>
}